import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StorageService } from "../../../services/storage.service";
import { Uris } from "../../../services/Uris";
import { Dispenser, DispenserBody, PaginatedDispensers } from "../interfaces/dispenser.interfaces";

@Injectable({
  providedIn: "root"
})
export class DispenserService {
  constructor(
    private http: HttpClient,
    public router: Router,
    public storageService: StorageService
  ) {}

  /**
   * Obtiene la lista paginada de dosificadores.
   * @param query Cadena de query params, ej: `?page=1&page_size=30`.
   * @returns Observable con la respuesta paginada.
   */
  listDispensers(query: string = ""): Observable<PaginatedDispensers> {
    return this.http
      .get<PaginatedDispensers>(`${Uris.DISPENSERS}${query}`, this.storageService.headers())
      .pipe(
        map((resp: PaginatedDispensers) => {
          return resp;
        })
      );
  }

  /**
   * Obtiene un dosificador por su ID.
   * @param id Identificador del dosificador.
   * @returns Observable con los datos del dosificador.
   */
  getDispenserById(id: number): Observable<Dispenser> {
    return this.http.get<Dispenser>(`${Uris.DISPENSERS}${id}/`, this.storageService.headers()).pipe(
      map((resp: Dispenser) => {
        return resp;
      })
    );
  }

  /**
   * Crea un nuevo dosificador.
   * @param value Datos del nuevo dosificador.
   * @returns Observable con el dosificador creado.
   */
  createDispenser(value: DispenserBody): Observable<Dispenser> {
    return this.http
      .post<Dispenser>(`${Uris.DISPENSERS}`, value, this.storageService.headers())
      .pipe(
        map((resp: Dispenser) => {
          this.storageService.animation(
            "success",
            "Éxito",
            `Dosificador ${resp.name} creado correctamente`
          );
          return resp;
        })
      );
  }

  /**
   * Edita un dosificador existente.
   * @param id Identificador del dosificador.
   * @param value Datos a actualizar.
   * @returns Observable con el dosificador actualizado.
   */
  editDispenser(id: number, value: DispenserBody): Observable<Dispenser> {
    return this.http
      .patch<Dispenser>(`${Uris.DISPENSERS}${id}/`, value, this.storageService.headers())
      .pipe(
        map((resp: Dispenser) => {
          this.storageService.animation(
            "success",
            "Éxito",
            `Dosificador ${resp.name} editado correctamente`
          );
          return resp;
        })
      );
  }

  /**
   * Elimina un dosificador por su ID.
   * @param id Identificador del dosificador.
   * @returns Observable con la respuesta del servidor.
   */
  deleteDispenser(id: number): Observable<any> {
    return this.http.delete(`${Uris.DISPENSERS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Dosificador eliminado correctamente`);
        return resp;
      })
    );
  }
}
